import { sortBy } from 'lodash'
import { gcpStoragePlanFilesUrl, gcpStoragePlanFilesUrl_2025 } from '../consts'
import html2canvas from 'html2canvas'
// Function to calculate the range of the monthly price (best_rate)
export const calculateMonthlyPriceRange = plans => {
  let minPrice = plans?.[0]?.plan_rate_multiplied
  let maxPrice = plans?.[0]?.plan_rate_multiplied

  plans.forEach(plan => {
    const price = plan?.plan_rate_multiplied
    if (price < minPrice) {
      minPrice = price
    }
    if (price > maxPrice) {
      maxPrice = price
    }
  })

  return { minPrice, maxPrice }
}

export const getPriceAsFloat = price => {
  return price ? parseFloat(price?.replace('$', '').replace(',', '')) : 0
}

// Function to calculate the range of the annual deductible
export const calculateAnnualDeductibleRange = plans => {
  let minPrice = getPriceAsFloat(plans?.[0]?.details?.Annual_Deductible)
  let maxPrice = getPriceAsFloat(plans?.[0]?.details?.Annual_Deductible)

  plans.forEach(plan => {
    const deductible = getPriceAsFloat(plan?.details?.Annual_Deductible)
    if (deductible < minPrice) {
      minPrice = deductible
    }
    if (deductible > maxPrice) {
      maxPrice = deductible
    }
  })

  return { minPrice, maxPrice }
}

// Function to check if any of the coverage filters are included in the plan name
export const isIncludedInPlanCoverage = (planName, coverageFilter) => {
  return !!coverageFilter?.find(filter =>
    planName?.toLowerCase()?.includes(filter?.toLowerCase())
  )
}

export const sortPlansLowToHigh = plans => {
  const sortedPlans = sortBy(plans, plan => {
    return plan?.plan_rate_multiplied
  })

  return sortedPlans
}

export const sortPlansHighToLow = plans => {
  const sortedPlans = sortBy(plans, plan => {
    return plan?.plan_rate_multiplied
  }).reverse()

  return sortedPlans
}

export const sortPlansByRank = (plans, rankToSortBy) => {
  const selectedRank = rankToSortBy || 'low' // Default to low if no rank is selected
  const sortedPlans = sortBy(plans, plan => {
    const rank = plan?.plan_rankings?.find(
      ranking => ranking?.rank_name === selectedRank
    )
    return rank ? rank?.value : 0 // Default to 0 if rank_name is not found
  })

  return sortedPlans
}

export const isPlanFavorite = (plan, savedPlans) => {
  return !!savedPlans?.find(
    savedPlan => savedPlan?.antidote_plan_id === plan?.antidote_plan_id
  )
}

export const getPlanFileUrl = plan => {
  let url = gcpStoragePlanFilesUrl_2025
  if (plan.year == 2024) {
    url = gcpStoragePlanFilesUrl
  }
  return plan?.plan_file_name ? `${url}/${plan?.plan_file_name}` : null
}


export const captureScreenshot = async ({ classId }) => {
  const element = document.getElementById(classId) // The React component or element to capture
  // Temporarily hide the elements that are not rendered correctly
  const unwantedElements = Array.from(
    element.querySelectorAll('.not-share-friendly')
  )
  unwantedElements.forEach(el => el.classList.add('hidden'))
  // the backgroud is transparent and its not butiful in the mail
  // lats bring back the background
  element.classList.add('add-visible-background')

  const canvas = await html2canvas(element, { logging: true, useCORS: true })
  const dataUrl = canvas.toDataURL('image/png')

  // Show the unwanted elements again
  unwantedElements.forEach(el => el.classList.remove('hidden'))
  element.classList.remove('add-visible-background')

  return dataUrl // This is a base64 encoded string of the image
}